import React from "react";
import "./SlugPage.css"
const SanitySeoKeywords = ({ keywords = [] }) => {
  if (!keywords || keywords.length === 0) return null;

  return (
    <div className="keywords-container">
      <ul className="keywords-list">
        {keywords.map((item, index) => (
          <li key={index} className="keywords-item">
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SanitySeoKeywords;